import { AssetModelData } from "../../files/asset.interface";
import { FileObject } from "../../files/file-object";

export const resolveAssetPaths = (file: FileObject, asset: AssetModelData) => {
  let convertedFilePath: string | undefined;
  if (file.operation) {
    // Take the result of completed file operations and assign them to
    // the convertedFilePath property
    const operation = asset?.jobs?.[file.operation?.name];

    if (operation?.status === "done" && operation?.result) {
      if ("hd" in operation.result) {
        // Take the HD variant for video transcode operations
        convertedFilePath = operation.result.hd;
      } else if ("url" in operation.result) {
        // Take the url for remove background & trackable operations
        convertedFilePath = operation.result.url;
      }
    }
  }
  return {
    path: asset?.src,
    convertedFilePath,
  };
};
